var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BlogPost',{attrs:{"blog-post":_vm.blogPost}}),_vm._v(" "),_c('FooterJoin',{attrs:{"title":"Want to **contribute?**","text":"Write a post in collaboration with us and get featured on the Baserow Blog.","buttons":[
      {
        id: '1',
        value: {
          type: 'primary',
          text: 'Submit your post',
          url_or_path: '/blog/how-to-contribute-to-the-baserow-blog',
        },
      },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }